// SMART DEMO — Lavia Davet & Organizasyon asset manifest (FINAL EXPORT)
// Kontrollü static asset paketi için TEK KAYNAK path tanımı.
//
// Bu dosya yalnızca PATH tanımlar; binary (image/video) üretmez, indirmez.
// Kullanıcı projeyi download ettikten sonra binary dosyaları public/ altındaki
// exact klasörlere koyar ve local build alır. HİÇBİR .ts/.tsx dosyasına dokunmaz.
//
// Final asset seti (15 binary):
//   1 logo + 4 wedding + 4 engagement + 4 birthday + 2 video
//
// Dış URL / hotlink / stock / Stable Diffusion external URL YOK.
// Readdy Files / Supabase Storage YOK — tüm media kullanıcının kendi serverından.
// Sahte gerçek firma YOK — "Lavia Davet & Organizasyon" tamamen kurgu demo markadır.

export const LAVIA_EVENT_ASSET_ROOT = "/demo-presets/event/lavia-event";

export interface LaviaEventManifest {
  logo: string;
  wedding: string[];
  engagement: string[];
  birthday: string[];
  videos: string[];
}

export const LAVIA_EVENT_MANIFEST: LaviaEventManifest = {
  logo: `${LAVIA_EVENT_ASSET_ROOT}/logo/logo.webp`,
  wedding: [
    `${LAVIA_EVENT_ASSET_ROOT}/wedding/01.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/wedding/02.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/wedding/03.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/wedding/04.webp`,
  ],
  engagement: [
    `${LAVIA_EVENT_ASSET_ROOT}/engagement/01.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/engagement/02.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/engagement/03.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/engagement/04.webp`,
  ],
  birthday: [
    `${LAVIA_EVENT_ASSET_ROOT}/birthday/01.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/birthday/02.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/birthday/03.webp`,
    `${LAVIA_EVENT_ASSET_ROOT}/birthday/04.webp`,
  ],
  videos: [
    `${LAVIA_EVENT_ASSET_ROOT}/videos/01.mp4`,
    `${LAVIA_EVENT_ASSET_ROOT}/videos/02.mp4`,
  ],
};